import { usePageEditorContext } from '../../contexts/page-editor.context'
import { Accordion, AccordionSummary, AccordionDetails } from '../sidebar-accordion'
import { ManualBlockEditor } from '../manual-block-editor'
import { CategoryListEdit } from '../category-list-edit'

export const PageControlBarEditSidebar = function () {
  const pageEditorContext = usePageEditorContext() || {}
  const { currentEdit } = pageEditorContext || {}
  const block = currentEdit.block
  const pageControlBar = block.pageControlBar

  function updateBlock (block) {
    pageEditorContext.registerUnsavedChanges()
    pageEditorContext.updateCurrentEdit({ block: { ...block } })
  }

  function getEditableFilters () {
    return [{
      values: pageControlBar.filterDefinition.fields.map((filter) => {
        filter.value = filter.key
        return filter
      })
    }]
  }

  function updateFilterLabels (updates) {
    pageControlBar.filterDefinition = { ...pageControlBar.filterDefinition }
    pageControlBar.filterDefinition.fields = updates[0].values.map((filter) => {
      delete filter.value
      return filter
    })
    updateBlock(block)
  }

  function getEditableFilterOptions () {
    if (!pageControlBar.filterDefinition || !pageControlBar.filterDefinition.fields) {
      return []
    }

    return pageControlBar.filterDefinition.fields.map((x) => {
      const values = x.options ? [...x.options] : []
      x = { ...x, value: x.key, values }
      delete x.options
      return x
    })
  }

  function updateFilterOptionLabels (updates) {
    pageControlBar.filterDefinition = { ...pageControlBar.filterDefinition }
    // map "values" back into "options"
    pageControlBar.filterDefinition.fields = updates.map((x) => {
      x = { ...x }
      x.options = x.values
      delete x.value // same as key
      delete x.values
      return x
    })
    updateBlock(block)
  }

  return <div className="report-editor-sidebar">
    <Accordion square defaultExpanded={true}>
      <AccordionSummary>
        Filters
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <CategoryListEdit
              size="medium"
              categories={getEditableFilters()}
              hideCategoryDropdown={true}
              hideLabelToggles={true}
              onChange={updateFilterLabels}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
    <Accordion square defaultExpanded={true}>
      <AccordionSummary>
        Filter Options
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <CategoryListEdit
              size="medium"
              categoryLabel="Filter"
              listLabel="Filter Option Labels"
              categories={getEditableFilterOptions()}
              onChange={updateFilterOptionLabels}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
    <Accordion square>
      <AccordionSummary>
        Other
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <ManualBlockEditor block={currentEdit.block} onChange={updateBlock} />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  </div>
}
